import { render, staticRenderFns } from "./PageHeaderLogo.vue?vue&type=template&id=4af68616&"
import script from "./PageHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./PageHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/pages/black-friday.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports